import { CustomerData } from '@/containers/widget/embedScript';
import { CustomerFormValues } from './embedPageState';

const CUSTOMER_DATA_MAX_LENGTH = 200;
// eslint-disable-next-line no-control-regex
const CONTROL_CHARACTERS = /[\u0000-\u001F\u007F]/;
const EMAIL_PATTERN =
    /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+.-]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9-]*\.)+[A-Za-z]{2,}$/;

const CUSTOMER_FIELDS: (keyof CustomerFormValues)[] = ['firstName', 'lastName', 'email', 'phone'];

export type CustomerFieldErrors = Partial<Record<keyof CustomerFormValues, string>>;

export const validateCustomerForm = (values: CustomerFormValues): CustomerFieldErrors =>
    Object.fromEntries(
        CUSTOMER_FIELDS.map((field) => [field, validateCustomerField(field, values[field])]).filter(
            ([, error]) => error !== undefined
        )
    );

const validateCustomerField = (
    field: keyof CustomerFormValues,
    value: string
): string | undefined => {
    const trimmed = value.trim();
    if (trimmed.length > CUSTOMER_DATA_MAX_LENGTH)
        return `Max ${CUSTOMER_DATA_MAX_LENGTH} characters`;
    if (CONTROL_CHARACTERS.test(trimmed)) return 'Control characters are not allowed';
    if (field === 'email' && trimmed && !EMAIL_PATTERN.test(trimmed))
        return 'Invalid email address';
    return undefined;
};

export const toCustomerData = (values: CustomerFormValues): CustomerData | null => {
    if (Object.keys(validateCustomerForm(values)).length > 0) return null;
    return Object.fromEntries(
        CUSTOMER_FIELDS.map((field) => [field, values[field].trim()]).filter(
            ([, value]) => value !== ''
        )
    );
};
